import React, { forwardRef } from 'react';

import { alpha } from '@mui/material';
import clsx from 'clsx';
import type { AlineButtonProps } from 'src/components';
import { AlineButton } from 'src/components';
import { CrossIcon } from 'src/components/icons/CrossIcon';
import { IconColors } from 'src/components/icons/icon-utils';
import { makeStyles } from 'tss-react/mui';

interface CrossIconButtonProps extends AlineButtonProps {
  text: string;
  paddingRightPx?: number;
}

const useStyles = makeStyles<Pick<CrossIconButtonProps, 'paddingRightPx'>>()(
  (theme, { paddingRightPx }) => ({
    button: {
      borderRadius: 24,
      height: 'unset',
      padding: `12px ${paddingRightPx ?? 12}px 12px 12px`,
    },
    crossIcon: {
      height: 16,
      width: 16,
    },
    iconCircle: {
      alignItems: 'center',
      backgroundColor: theme.palette.common.white,
      borderRadius: '50%',
      display: 'flex',
      height: 24,
      justifyContent: 'center',
      marginRight: theme.spacing(1),
      width: 24,
    },
  })
);

export const CrossIconButton = forwardRef(function CrossIconButton(
  { buttonClassName, paddingRightPx, text, ...buttonProps }: CrossIconButtonProps,
  ref: React.Ref<HTMLButtonElement>
): JSX.Element {
  const { classes } = useStyles({ paddingRightPx });

  return (
    <AlineButton
      ref={ref}
      buttonClassName={clsx(classes.button, buttonClassName)}
      color="primary"
      variant="contained"
      {...buttonProps}
    >
      <div className={classes.iconCircle}>
        <CrossIcon
          className={classes.crossIcon}
          fill={buttonProps.disabled ? alpha(IconColors.Primary, 0.5) : IconColors.Primary}
        />
      </div>
      {text}
    </AlineButton>
  );
});
